function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 56,
    viewBox: "0 0 49 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57483",
    d: "M99.5 0A3.51 3.51 0 0 0 96 3.5v49a3.51 3.51 0 0 0 3.5 3.5h35a3.51 3.51 0 0 0 3.5-3.5V14L124 0z",
    transform: "translate(-89)",
    style: {
      fill: "#e2e5e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57484",
    d: "M355.5 14H366L352 0v10.5a3.51 3.51 0 0 0 3.5 3.5z",
    transform: "translate(-317)",
    style: {
      fill: "#b0b7bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57485",
    d: "M394.5 138.5 384 128h10.5z",
    transform: "translate(-345.5 -114)",
    style: {
      fill: "#cad1d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57486",
    d: "M74 259.25a1.755 1.755 0 0 1-1.75 1.75h-38.5a1.755 1.755 0 0 1-1.75-1.75v-17.5a1.755 1.755 0 0 1 1.75-1.75h38.5a1.755 1.755 0 0 1 1.75 1.75z",
    transform: "translate(-32 -213.75)",
    style: {
      fill: "#50bee8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17214"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57487",
    d: "M84.71 305.155a.877.877 0 0 1-.966-.868v-7.947a.951.951 0 0 1 .966-.868h3.2c6.395 0 6.253 9.683.124 9.683zm.882-7.976v6.268h2.322c3.778 0 3.945-6.268 0-6.268z",
    transform: "translate(-78.085 -263.155)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57488",
    d: "M185.036 302.445a4.886 4.886 0 0 1-5.276-5.038 5.142 5.142 0 0 1 10.285 0 4.88 4.88 0 0 1-5.009 5.038zm-.154-8.353a3.317 3.317 0 1 0 3.33 3.316 3.2 3.2 0 0 0-3.33-3.316z",
    transform: "translate(-163.599 -260.305)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57489",
    d: "M288.848 298.191a4.71 4.71 0 0 1 4.912-5.022 4.573 4.573 0 0 1 3.2 1.246.907.907 0 1 1-1.246 1.314 2.415 2.415 0 0 0-1.958-.768 3.023 3.023 0 0 0-3.189 3.232 3.077 3.077 0 0 0 3.189 3.33 3.268 3.268 0 0 0 2.184-.9.939.939 0 0 1 1.286.168.965.965 0 0 1-.154 1.314 4.577 4.577 0 0 1-3.318 1.094c-3.38.001-4.906-2.308-4.906-5.008z",
    transform: "translate(-260.756 -261.103)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57490",
    d: "M129.25 417.75H96v1.75h33.25a1.755 1.755 0 0 0 1.75-1.75V416a1.755 1.755 0 0 1-1.75 1.75z",
    transform: "translate(-89 -370.5)",
    style: {
      fill: "#cad1d8"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.c04ac0827075fba6738ce273901b394b.svg";
export { ForwardRef as ReactComponent };